<template>
  <div style="height: 100%; width: 100%;">
    <div id="IPQCChartfour" style="height: calc(100% - 32px); width: 100%;"></div>
  </div>
</template>

<script>
export default {
  props: [],
  data () {
    return {
      option: {
        title: {
          text: this.$t('All.系统统计每个用户日期范围内数量')
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['Email', 'Union Ads', 'Video Ads']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // 下载
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'Email',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: 'Union Ads',
            type: 'line',
            stack: 'Total',
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: 'Video Ads',
            type: 'line',
            stack: 'Total',
            data: [150, 232, 201, 154, 190, 330, 410]
          }
        ]
      },
      myChart: null
    }
  },
  mounted () {
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth()

    // 当前月份的第一天
    const monthStart = this.formatDate(new Date(year, month, 1))

    // 当前月份的最后一天
    const monthEnd = this.formatDate(new Date(year, month + 1, 0))
    this.Getdata(this.$store.state.Login.Factory === 'All' ? 'TC' : this.$store.state.Login.Factory, monthStart, monthEnd)
    window.addEventListener('resize', this.resizechart)
  },
  methods: {
    resizechart () {
      if (this.myChart !== null && this.myChart !== undefined) {
        this.myChart.resize()
      }
    },
    // 格式化函数，确保月份和日期为两位数
    formatDate (date) {
      const y = date.getFullYear()
      const m = (date.getMonth() + 1).toString().padStart(2, '0') // 月份加 1，确保两位数
      const d = date.getDate().toString().padStart(2, '0') // 确保日期是两位数
      return `${y}-${m}-${d}`
    },
    async Getdata (cq, monthStart, monthEnd) {
      try {
        this.myChart = this.$echarts.init(document.getElementById('IPQCChartfour'))
        this.myChart.resize()
        this.myChart.clear()
        const { data: res } = await this.$http.post(`api/Newiqc/Getiqcalluserdatesum?Factory=${cq}&Type=IPQC&Start=${monthStart}&End=${monthEnd}`)
        if (res.status !== 200) return this.$message.error(res.msg)
        this.option.xAxis.data = res.Date
        this.option.series = res.response
        this.option.legend.data = res.response.map(x => x.name)
        this.myChart.setOption(this.option, true)
      } catch (error) {
        return this.$message.error(error)
      }
    }
  }
}
</script>
